export default function AppointmentDetailsPage() {
    return <>AppointmentDetailsPage</>;
}
